import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "Milliseid piirkondi te teenindate?",
    answer: "Teenindame üle kogu Eesti – Tallinn, Tartu, Pärnu, Rakvere, Narva, Viljandi, Haapsalu ja kõik teised linnad ning maakonnad."
  },
  {
    question: "Kui kiiresti saate koristustööga alustada?",
    answer: "Tavaliselt saame alustada 1-3 tööpäeva jooksul pärast lepingu sõlmimist. Kiireloomulistel juhtudel on võimalik ka samal päeval alustada."
  },
  {
    question: "Kas pakute ka ühekordseid koristustöid?",
    answer: "Jah, pakume nii regulaarset hoolduskoristust kui ka ühekordseid teenuseid nagu suurpuhastus, ehitusjärgne koristus ja eripuhastustööd."
  },
  {
    question: "Kuidas toimub hinnapakkumise saamine?",
    answer: "Hinnapakkumine on tasuta! Võtke meiega ühendust telefoni, e-posti või kontaktvormi kaudu ning teeme teile sobiva pakkumise 24 tunni jooksul."
  },
  {
    question: "Milliseid puhastusvahendeid te kasutate?",
    answer: "Kasutame professionaalseid ja keskkonnasõbralikke puhastusvahendeid ning kaasaegseid töövahendeid, mis tagavad parima tulemuse ilma keskkonda kahjustamata."
  },
];

const FAQSection = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section id="faq" className="py-24 bg-secondary/30">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <p className="text-primary text-sm uppercase tracking-widest mb-3 font-medium">
            Küsimused
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground mb-4">
            Korduma kippuvad küsimused
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="bg-card rounded-2xl border border-border/50 px-6 shadow-sm"
              >
                <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
